export const getters = {
  permissions: state => state.permissions
}

export default getters
